import { Button, ButtonProps, ImgIcons } from "imaginarity-react-ui";
import * as React from "react";
import { useImgI18N } from "services/ImgI18N";
import styled from "styled-components";

const OuterContainer = styled.div`
    button>div{margin: 0;}
`;

interface CancelWithConfirmationProps {
    namespace?: string;
    cancel: () => void;
    children?: JSX.Element;
    cancelText?: string;
    confirmText?: string;
    icon?: ImgIcons;
    iconOnly?: boolean;
    floated?: "left" | "right";
    tooltipInitialButton?: string;
    kind?: ButtonProps["kind"];
    kindConfirm?: ButtonProps["kind"];
    iconColor?: string;
    size?: ButtonProps["size"];
    openAbsolute?: boolean;
}

const CancelWithConfirmation = (p: CancelWithConfirmationProps) => {
    const { namespace, cancel, children, cancelText, confirmText, iconOnly, floated, icon, tooltipInitialButton, kind, iconColor, size, kindConfirm, openAbsolute } = p;
    const [check, setCheck] = React.useState<boolean>(false);
    const { t } = useImgI18N(namespace ?? "general");

    const cancelProcess = () => {
        setCheck(false);
        cancel();
    }

    return (
        <OuterContainer style={{ float: floated ?? "left", position: "relative" }}>
            <Button
                kind={check ? "secondary" : (kind ?? "secondary")}
                icon={check ? "times" : icon ?? "times"}
                iconColor={check ? undefined : iconColor}
                onClick={() => setCheck(!check)}
                floated={floated ?? "left"}
                content={iconOnly ? undefined : check ? undefined : t(cancelText ?? "cancel")}
                tooltip={tooltipInitialButton ? { tooltipText: check ? t(cancelText ?? "cancel") : t(tooltipInitialButton), position: "bottom" } : undefined}
                size={size ?? "default"}
            />
            {check &&
                <>
                    {openAbsolute ?
                        <div style={{ position: "absolute", top: -20, right: 40, padding: "20px 0 20px 20px" }} onMouseLeave={() => setCheck(false)}>
                            <Button
                                kind={kindConfirm ?? "primary"}
                                icon="check"
                                onClick={cancelProcess}
                                floated={floated ?? "left"}
                                content={t(confirmText ?? "yes, cancel process")}
                                size={size ?? "default"}
                            />
                        </div>
                        :
                        <Button
                            kind={kindConfirm ?? "primary"}
                            icon="check"
                            onClick={cancelProcess}
                            floated={floated ?? "left"}
                            content={t(confirmText ?? "yes, cancel process")}
                            size={size ?? "default"}
                        />
                    }
                </>
            }
            {children}
        </OuterContainer>

    )
}

export default CancelWithConfirmation;